import { combineReducers } from "redux";
import paymentReducer from "./reducer";

const reducer = combineReducers({
  paymentReducer,
});

export default reducer;
